import React from 'react';
import { secondsToMinutes } from '../../../../../apps/frontend/src/utils/utilFunctions';
import TableHeader from '../../components/generic/TableHeader';
import TimeAnalysisSkeleton from './TimeAnalysisHourSkeleton';
import NoData from '../generic/NoData';

const TimeAnalysisSubjectChart = ({ data, loading, onResetFilters }) => {
  if (loading) return <TimeAnalysisSkeleton />;
  if (!data || Object.keys(data).length === 0) return <NoData onResetAll={onResetFilters} />;

  const subjectData = Object.keys(data)
    .map((key) => ({
      ...data[key],
      percentage: parseFloat(data[key].percentage) || 0,
      time: secondsToMinutes(data[key].timeSpent),
    }))
    .filter((item) => !isNaN(item.percentage));

  const totalTime = subjectData.reduce((sum, item) => sum + (item.timeSpent || 0), 0);

  return (
    <div>
      <TableHeader headerTitle="Summary - Subject-wise Time" showBottomBorder={false}>
        <div className="border border-[var(--q3-stroke-light)] rounded-b-lg p-6">
          {/* Legend */}
          <div className="flex items-center gap-4 mb-4 flex-wrap">
            {subjectData.map((item, index) => (
              <div key={index} className="flex items-center gap-2">
                <div
                  style={{
                    backgroundColor: item.subjectMeta?.color || '#6b7280',
                  }}
                  className={`w-3 h-3 bg-[${item.subjectMeta.color}] rounded-sm`}
                ></div>
                <span className="text-sm text-[var(--q3-neutral-default)]">
                  <span className="uppercase">{item.subjectMeta?.title}</span>:{' '}
                  <span className="font-semibold">{item.time} min</span>
                </span>
              </div>
            ))}
          </div>

          {/* Bar Chart */}
          {totalTime > 0 && (
            <div className="flex overflow-hidden h-12 mb-4 rounded-[2px] bg-[--q3-surface-default]">
              {subjectData
                .filter((item) => item.percentage > 0)
                .map((item, index, arr) => {
                  const isFirst = index === 0;
                  const isLast = index === arr.length - 1;

                  return (
                    <div
                      key={index}
                      className={` flex items-center justify-center text-[var(--q3-surface-default)] font-medium`}
                      style={{
                        width: `${item.percentage}%`,
                        marginRight: !isLast ? '2px' : '0',
                        borderTopLeftRadius: isFirst ? '2px' : '0',
                        borderBottomLeftRadius: isFirst ? '2px' : '0',
                        borderTopRightRadius: isLast ? '2px' : '0',
                        borderBottomRightRadius: isLast ? '2px' : '0',
                        backgroundColor: item.subjectMeta?.color || '#6b7280',
                      }}
                    >
                      {Math.round(item.percentage)}%
                    </div>
                  );
                })}
            </div>
          )}

          {/* Total Time */}
          <div className="text-left">
            <span className="text-lg text-[var(--q3-neutral-default)]">
              Overall Time: <span className="font-bold">{secondsToMinutes(totalTime)} min</span>
            </span>
          </div>
        </div>
      </TableHeader>
    </div>
  );
};

export default TimeAnalysisSubjectChart;
